import { Component, EventEmitter, Input, OnInit, Output, TemplateRef, ViewChild } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { AlertifyService } from '../../services/alertify.service';
import { DatePipe } from '@angular/common';
import { SystemService } from '../../services/system.service';
import { Documenttype } from '../documenttype/documenttype';
import { TypeModel } from '../../model/type';
import { QuestionsService } from '../../services/questions.service';
import { QuestionnaireService } from '../../services/questionnaire.service';

@Component({
    selector: 'app-questions-listSub',
    templateUrl: './questions-listSub.component.html',
    styleUrls: ['./questions-listSub.component.scss'],
    providers: [DatePipe],
})
export class QuestionsListSubComponent implements OnInit {
    QuestionsForm: FormGroup;
    type: TypeModel; public allowedExtensions: Array<string> = ["png", "jpg", "jpeg", "gif", "bmp"];
    userSubmitted: boolean;
    file: any;
    fileExtension: any;
    filepostedOn = new Date().toString().split("+")[0].split(':').join('_');
    imageUrl: string | ArrayBuffer = "https://www.adc-awards.archi/images/joomlart/demo/default.jpg"
    @ViewChild('editor') editor;
    fileName: any;
    documentTypelist: any;
    typelist: any;
    data: any;id: any;
    isLoading = false;QuestionnaireId: any;QuestionnarireName: any;
    @Input() documenttype: Documenttype[] = [];
    @Output() editDocumenttype = new EventEmitter<Documenttype>();
    @Output() deleteDocumenttype = new EventEmitter<number>();

    constructor(private fb: FormBuilder, private questionnaireService: QuestionnaireService,
        private router: Router, private questionService: QuestionsService, private alertify: AlertifyService,private route: ActivatedRoute,
        public service: SystemService) {  this.id = this.route.snapshot.paramMap.get('id'); }

    ngOnInit() {
        this.bindQuestionnairesById();
        // this.binddataQuestions();
        this.refreshGridData();
    }


    bindQuestionnairesById() {
        try {
            console.log(this.id);
            this.questionnaireService.getQuestionnairesById(Number(this.id)).then(data => {
                data = this.convertKeysToCamelCase(data);
                console.log(data);
                this.QuestionnaireId = data.Id;
                this.QuestionnarireName = data.Name;
                console.log(this.QuestionnaireId);
                console.log(this.QuestionnarireName);
            });
        } catch (error) {
            // Handle errors here
            console.error("Error submitting questionnaire:", error);
            this.alertify.error("An error occurred while saving data.");
        }
    }

    convertKeysToCamelCase(obj: any): any {
        if (obj === null || typeof obj !== 'object') {
            return obj;
        }

        if (Array.isArray(obj)) {
            return obj.map((item) => this.convertKeysToCamelCase(item));
        }

        return Object.keys(obj).reduce((acc, key) => {
            const camelCaseKey = key.charAt(0).toUpperCase() + key.slice(1);
            acc[camelCaseKey] = this.convertKeysToCamelCase(obj[key]);
            return acc;
        }, {});
    }


    private gridApi: any;
    private gridColumnApi: any;

    columnDefs = [

        {
            headerName: 'Id', field: 'Id', sortable: true, filter: true, width: 20, headerCheckboxSelection: true,
            checkboxSelection: true,
            showDisabledCheckboxes: true
        },
        { headerName: 'QuestionnaireId', field: 'QuestionnaireId', sortable: true, filter: true, editable: true, width: 150 },
        { headerName: 'QuestionType', field: 'QuestionType', sortable: true, filter: true, editable: true, width: 100 },
        { headerName: 'Identifier', field: 'Identifier', sortable: true, filter: true, editable: true, width: 100 },
        { headerName: 'Headline', field: 'Headline', sortable: true, filter: true, editable: true, width: 150 },
        //{ headerName: 'Description', field: 'description', sortable: true, filter: true, editable: true, width: 200 },
        { headerName: 'Required', field: 'Required', sortable: true, filter: true, editable: true, width: 100 },
        { headerName: 'Multiple', field: 'Multiple', sortable: true, filter: true, editable: true, width: 100 },
        { headerName: 'Multiline', field: 'Multiline', sortable: true, filter: true, editable: true, width: 100 },
        {
            headerName: 'Actions',
            cellRenderer: this.actionsCellRenderer.bind(this),
            sortable: false,
            filter: false,
            width: 180
        },
    ];

    defaultColDef = {
        flex: 1,
        minWidth: 100,
        resizable: true,

    };

    rowData: any;

    binddata() {
        this.service.App.ShowLoader = true;
        this.questionnaireService.getAllQuestionnaires().then(data => {
            console.log(data);
            this.rowData = data;
        });
        this.service.App.ShowLoader = false;
    }



    onGridReady(params: any) {
        this.gridApi = params.api;
        this.gridColumnApi = params.columnApi;
    }

    imageCellRenderer(params: any) {
        return `<img src="${params.value}" alt="Image" style="max-width: 50px; max-height: 50px;">`;
    }
    actionsCellRenderer(params: any) {
        // const addButton = document.createElement('button');
        // addButton.innerHTML = 'Add';
        // addButton.classList.add('Actions-btn'); // Apply the CSS class
        // addButton.addEventListener('click', () => this.addRow());

        const editButton = document.createElement('button');
        editButton.innerHTML = 'Edit';
        editButton.classList.add('Actions-btn'); // Apply the CSS class
        editButton.addEventListener('click', () => this.editRow(params.data));

        const deleteButton = document.createElement('button');
        deleteButton.innerHTML = 'Delete';
        deleteButton.classList.add('Actions-btn'); // Apply the CSS class
        deleteButton.addEventListener('click', () => this.deleteRow(params.data));


        const wrapper = document.createElement('div');
        wrapper.appendChild(editButton);
        // wrapper.appendChild(addButton);
        wrapper.appendChild(deleteButton);


        return wrapper;
    }

    onSelectionChanged(event: any) {
        const selectedNodes = event.api.getSelectedNodes();

        if (selectedNodes.length > 0) {
          // At least one row is selected
          const selectedNode = selectedNodes[0];
          const selectedData = selectedNode.data;
          console.log('Row selected:', selectedData);
          this.router.navigate(['/choiceformadd', selectedData.Id]);
        } else {
          // No rows are selected
          console.log('Row deselected');
        }
    }


    addRow() {

        localStorage.setItem('questionnaireSub', this.id); // passing global Id not local Id due to we need questionnnaries Id
        this.router.navigate(['/questionsaddSub']);
    }
    editRow(rowData: any) {
        console.log('Edit row:', rowData);
        let id = rowData.Id;
        localStorage.setItem('questionnaireSub', this.id); // passing global Id not local Id due to we need questionnnaries Id
        this.router.navigate(['/questionseditSub', id]);

    }
    deleteRow(rowData: any) {
        console.log('rowDatadelete', rowData);
        const confirmation = window.confirm('Are you sure you want to delete?');

        if (confirmation) {
            let res = this.questionService.deleteQuestion(rowData.Id).then(res => {
                if (res) {
                    this.refreshGridData();
                    this.alertify.success("Deleted Successfully");
                } else {
                    this.refreshGridData();
                    this.alertify.error("Try again! or Contact admin!");
                }
                console.log(JSON.stringify(res));
            }).catch(error => {
                console.error("Error deleting questions:", error);
                this.alertify.error("An error occurred while deleting the data.");
            });
        } else {
            // User canceled the deletion
            console.log('Deletion canceled by user.');
        }
    }
    refreshGridData(): void {
        this.binddataQuestions();
        this.gridApi.setRowData(this.rowData); // Refresh the grid with the updated data
     }


    async binddataQuestions() {
        try {
            this.service.App.ShowLoader = true;
            const data = await this.questionService.getAllQuestionId(this.id);
            console.log(data);
            this.data = data;
            this.rowData = data;
            this.alertify.success("Data Loaded Successfully");
        } catch (error) {
            console.error("Error loading questions:", error);
            // Handle the error, e.g., show a user-friendly message
            this.alertify.error("An error occurred while loading data.");
        } finally {
            this.service.App.ShowLoader = false;
        }
    }



}

